import React from 'react'
import { Field } from 'formik'
import Label from './formLabel'
/**
 * @param {array} options Contains array of object to map over the radio input values
 */

const RadioButton = (props) => {
    const { label, name, options, handleValueChange, ...rest } = props
    return (
        <div className='form-group'>
            <Label name={name} label={label} />
            <div className='radio-Btn-wrapper'>
                <Field name={name} {...rest}>
                    {({ field }) => {
                        return options.map((option, index) => {
                            const className = `radioTab-label ${
                                field.value === option.value ? 'checked' : ''
                            } ${
                                index === 0
                                    ? 'borderRadius_left'
                                    : index === options.length - 1
                                    ? 'borderRadius_right'
                                    : ''
                            }`
                            return (
                                <div className='radioTab-box' key={option.key}>
                                    <label className={className}>
                                        {name === 'no_of_dependent'
                                            ? option.value
                                            : option.key}
                                        <input
                                            type='radio'
                                            className='inputRadio'
                                            id={option.value}
                                            {...field}
                                            {...rest}
                                            data-testid={
                                                option.key + '_' + name
                                            }
                                            value={option.value}
                                            checked={
                                                field.value === option.value
                                            }
                                        />
                                        <span className='checkmark'></span>
                                    </label>
                                </div>
                            )
                        })
                    }}
                </Field>
            </div>
        </div>
    )
}

export default RadioButton
